import React from 'react';
import { Modal } from '../ui/Modal';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';

const OrderNotAllowedModal = ({
  isOpen,
  onClose,
  allowAdvanceOrder,
  isTakeAway,
  fromKiosk = false,
}) => {
  const { language } = useDataContext();

  return (
    <Modal isOpen={isOpen} onClose={onClose} contentClassName="max-w-[420px]">
      <div className="text-center pt-8 px-6 pb-6">
        <div
          className="w-[72px] h-[72px] rounded-full flex items-center justify-center mx-auto mb-5 shadow-[0_4px_16px_rgba(255,152,0,0.3)]"
          style={{ background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)' }}
        >
          <span className="text-3xl">🕐</span>
        </div>

        <h3 className="text-xl font-bold text-[#1a1a1a] mb-2">
          {translations[language]?.order_not_allowed_modal_title}
        </h3>

        <p className="text-sm text-gray-500 leading-relaxed max-w-xs mx-auto mb-6">
          {translations[language]?.order_not_allowed_modal_message}{' '}
          {isTakeAway && allowAdvanceOrder && !fromKiosk && (
            <span>{translations[language]?.order_not_allowed_modal_advanced_order_message}</span>
          )}
        </p>

        <button
          className="w-full py-[14px] px-6 text-[15px] font-semibold bg-primary hover:bg-secondary text-white border-none rounded-xl cursor-pointer transition-colors duration-200"
          onClick={onClose}
        >
          {translations[language]?.close}
        </button>
      </div>
    </Modal>
  );
};

export default OrderNotAllowedModal;
